<template>
  <div class="detail-com">
    <div class="estate-info-con" v-if="estateDetail">
      <!-- 报修标题 -->
      <div class="info-title">
        <div class="title-top">
          <div>
            <span class="title labelCom">{{estateDetail.title}}</span>
            <span
              :class="estateDetail.overdue == 0 ? 'stateOverdue' : 'stateOverEnd'"
              class="state"
            >{{estateDetail.overdueName}}</span>
          </div>
          <span class="progressState">{{estateDetail.statusText}}</span>
        </div>
        <div>
          <span>
            <em class="labelCom">报修人：</em>
            {{estateDetail.petitionerName}}
          </span>
        </div>
        <div>
          <span class="time">报修时间：{{estateDetail.petitionTime}}</span>
        </div>
      </div>
      <!-- 报修进度 待分配无 -->
      <div class="info-progress" v-if="estateDetail.status !== 10">
        <van-steps :active="timeActive">
          <van-step>
            <h3 class="labelCom">首次分配</h3>
            <span>{{estateDetail.assignTime}}</span>
          </van-step>
          <van-step>
            <h3 class="labelCom">计划完成</h3>
            <span>{{estateDetail.expectedTime}}</span>
          </van-step>
          <van-step>
            <h3 class="labelCom">实际完成</h3>
            <span>{{estateDetail.maintainEndTime}}</span>
          </van-step>
        </van-steps>
        <div class="repairName">
          <span class="labelCom">维修人员：{{estateDetail.maintainerName}}</span>
          <span>联系电话：{{estateDetail.maintainerMobile}}</span>
        </div>
      </div>
      <!-- 所属楼层-->
      <div class="repairStyle" v-show="floorInfoList && floorInfoList.length > 0">
        <ul>
          <li :key="index" v-for="(item,index) in floorInfoList">
            <label class="labelCom">{{item.label}}：</label>
            <div class="imgList" v-if="item.type && item.type == 'imgList'">
              <span v-if="item.value && item.value.length >0">
                <span :key="imgInx" class="img" v-for="(img,imgInx) in item.value">
                  <img :src="img" alt />
                </span>
              </span>
              <span v-else>
                <img :src="defaultImg" alt />
              </span>
            </div>
            <span v-else>{{item.value}}</span>
          </li>
        </ul>
      </div>
      <!-- 处理方式 -->
      <div class="repairStyle" v-if="estateDetail.status == 30 || estateDetail.status == 40">
        <ul>
          <li :key="index" v-for="(item,index) in repairList">
            <label class="labelCom">{{item.label}}：</label>
            <div class="imgList" v-if="item.type && item.type == 'imgList'">
              <span v-if="item.value && item.value.length >0">
                <span :key="imgInx" class="img" v-for="(img,imgInx) in item.value">
                  <img :src="img" alt />
                </span>
              </span>
              <span v-else>
                <img :src="defaultImg" alt />
              </span>
            </div>
            <span v-else>{{item.value}}</span>
          </li>
        </ul>
      </div>
      <!-- 我的评分 -->
      <div class="myScore" v-if="estateDetail.status == 40">
        <h3 class="labelCom">我的评分：</h3>
        <ul>
          <li :key="index" v-for="(item,index) in estateDetail.appraisalVoList">
            <span>{{item.name}}</span>
            <van-rate color="#ff5603" readonly v-model="item.grade" />
            <span>{{item.gradeDes}}</span>
          </li>
        </ul>
      </div>
      <!-- 工单日志 -->
      <div class="workLog">
        <h3 class="labelCom">工单日志：</h3>
        <van-steps :active="1000" class="vanSteps" direction="vertical">
          <van-step :key="index" v-for="(item,index) in estateDetail.operationVOList">
            <p>{{item.operationTime}}</p>
            <p>{{item.statusName}}</p>
            <!-- <p>张三丰：13466608250</p> -->
            <p>{{item.userName}}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeActive: 1,
      floorInfoList: [],
      repairList: [],
      defaultImg: require('@/image/default.png'),
      detailData: []
    }
  },
  props: {
    estateDetail: {
      type: Object
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.detailData = this.estateDetail
      let detail = this.detailData
      this.timeActive = detail.maintainEndTime ? 2 : detail.expectedTime ? 1 : 0
      this.floorInfoList = [
        { label: '所属楼层', value: detail.floorName },
        { label: '报修类型', value: detail.typeName },
        { label: '报修内容', value: detail.detail },
        { label: '现在照片', value: detail.breakPic, type: 'imgList' }
      ]
      let servicePrice = '0'
      let clPrice = '0'
      detail.feeVoList &&
        detail.feeVoList.map(item => {
          if (item.feeItemId == 1) {
            servicePrice = item.amount
          } else if (item.feeItemId == 2) {
            clPrice = item.amount
          }
        })
      if (detail.repairType == 1) {
        this.repairList = [
          { label: '处理方式', value: detail.repairTypeName },
          { label: '服务费', value: servicePrice + '元' },
          { label: '材料费', value: clPrice + '元' },
          { label: '处理说明', value: detail.processDeclare },
          { label: '修后照片', value: detail.completePic, type: 'imgList' }
        ]
      } else {
        this.repairList = [
          { label: '处理方式', value: detail.repairTypeName },
          { label: '处理说明', value: detail.processDeclare },
          { label: '修后照片', value: detail.completePic, type: 'imgList' }
        ]
      }
    }
  },
  watch: {
    estateDetail() {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-com {
  font-size: px2rem(30);
  em {
    font-style: normal;
  }
  .labelCom {
    color: #0245bf;
    font-weight: 900;
    font-size: px2rem(32);
  }
  .estate-info-con {
    padding-bottom: px2rem(260);
    > div {
      background: #fff;
      padding: px2rem(20) px2rem(40);
    }
    .info-title {
      > div {
        margin: px2rem(25) 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .title-top {
        > div {
          width: 73%;
          display: flex;
          // justify-content: space-between;
          align-items: center;
        }
        .progressState-fp {
          color: #0245bf;
        }
        .progressState {
          color: #ff5400;
        }
        .title {
          max-width: 60%;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: px2rem(34);
          margin-right: px2rem(40);
        }
      }
      .time {
        color: #999;
      }
    }
    .info-progress {
      margin: px2rem(25) px2rem(10);
      .van-steps {
        background-color: #f5f5f5 !important;
        ::v-deep .van-step__circle-container {
          background-color: #f5f5f5 !important;
          top: 3.5rem;
        }
        ::v-deep .van-step__line {
          top: 3.5rem;
          background-color: #969799;
        }
        ::v-deep .van-step--finish {
          .van-step__line {
            background-color: #07c160;
          }
        }
      }
      ::v-deep .van-step__circle {
        width: 0.5rem;
        height: 0.5rem;
      }
      ::v-deep .van-step--horizontal .van-step__icon {
        font-size: 0.75rem !important;
      }
      ::v-deep .van-step__title {
        max-width: px2rem(130) !important;
        h3 {
          margin-bottom: px2rem(20);
        }
        > span {
          color: #999;
        }
      }
      .repairName {
        margin: px2rem(20) 0;
        text-align: center;
        span {
          display: block;
          margin: px2rem(15) 0;
        }
      }
    }
    .repairStyle {
      li {
        margin: px2rem(36) 0;
        display: flex;
        label {
          white-space: normal;
        }
        span {
          width: 70%;
          word-break: break-all;
          word-wrap: break-word;
          line-height: px2rem(42);
        }
        .imgList {
          width: 70%;
          margin: 0 auto;
          span.img {
            display: block;
            max-width: 100%;
            margin-bottom: px2rem(10);
            img {
              display: block;
              width: 100%;
            }
          }
        }
      }
    }
    .myScore {
      ul {
        margin: px2rem(20) 0;
        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: px2rem(18) 0;
          span {
            padding-right: px2rem(10);
          }
        }
      }
    }
    .state {
      padding: px2rem(10) px2rem(20);
      background: #0245bf;
      color: #fff;
      border-radius: px2rem(8);
    }
    .stateOverdue {
      background: #0245bf;
    }
    .stateOverEnd {
      background: #f92e93;
    }
    .info-progress {
      background: #f5f5f5;
    }
    .workLog {
      padding-bottom: px2rem(50);
      .vanSteps {
        p {
          padding: px2rem(8) 0;
        }
      }
    }
  }
}
</style>
